import { render } from "./RecentesSC.vue?vue&type=template&id=94af7e96&scoped=true"
import script from "./RecentesSC.vue?vue&type=script&lang=js"
export * from "./RecentesSC.vue?vue&type=script&lang=js"

import "./RecentesSC.vue?vue&type=style&index=0&id=94af7e96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94af7e96"]])

export default __exports__